import React, {useState} from "react";
import {Container, Row, Col, Form, Button, Table} from "react-bootstrap";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {
    getRefreshToken,
    getTokenFromSession,
    refreshIdToken,
} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";
import {format} from "date-fns";

const TransactionForm = () => {
    const [details, setDetails] = useState({
        customerId: "",
        transactionType: "Debit",
        amount: "",
        orderId: "",
    });

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = `0${d.getDate()}`.slice(-2);
        const month = `0${d.getMonth() + 1}`.slice(-2);
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };
    const [searchParams, setSearchParams] = useState({
        customerId: "",
        startDate: "",
        endDate: "",
    });
    const [transactions, setTransactions] = useState([]);

    const handleTransaction = async (e) => {
        e.preventDefault();
        console.log(searchParams.startDate, searchParams.endDate);
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.get(`${api.account}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                params: {
                    customerId: searchParams.customerId,
                    startDate: formatDate(searchParams.startDate),
                    lastDate: formatDate(searchParams.endDate),
                },
            });
            setTransactions(response.data);
        } catch (error) {
            console.log(error);
        }
    };
    const convertUnixTimestampToDate = (unixTimestamp) => {
        const date = new Date(unixTimestamp);
        return format(date, "yyyy-MM-dd hh:mm:ss a");
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        const token = getTokenFromSession();
        const body = JSON.stringify(details);
        try {
            const response = await axiosInstance.post(`${api.account}`, body, {
                params: {
                    method: "transaction",
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
            });
            if (response.status === 200) {
                alert("Transaction details added");
            }
            if (response.status === 204) {
                alert("Order is not found are CustomerId is not match a to order customer ID ")
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                const refreshToken = getRefreshToken();

                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                try {
                    await refreshIdToken(refreshToken);
                    await handleOnSubmit(e);
                } catch (refreshErr) {
                    console.error("Token refresh failed:", refreshErr);
                    window.location.href = "/";
                }
            }
        }
    };

    return (
        <>
            <Header/>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "100px",
                    marginLeft: "100px",
                }}
            >
                <Container className="mt-4">
                    <h3 className="mb-3">Transaction Form</h3>
                    <Form onSubmit={handleOnSubmit}>
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter Amount"
                                        required
                                        onChange={(e) => {
                                            setDetails({...details, amount: e.target.value});
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Customer ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Customer ID"
                                        required
                                        onChange={(e) => {
                                            setDetails({...details, customerId: e.target.value});
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Transaction Type</Form.Label>
                                    <Form.Select
                                        value={details.transactionType}
                                        onChange={(e) => {
                                            setDetails({
                                                ...details,
                                                transactionType: e.target.value,
                                            });
                                        }}
                                    >
                                        <option>Select Type</option>
                                        <option value="PURCHASE">PURCHASE</option>
                                        <option value="CREDIT">CREDIT</option>
                                        <option value="CAUTION_DEPOSIT">CAUTION_DEPOSIT</option>
                                        <option value="SHIPPING">SHIPPING</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>OrderID</Form.Label>
                                    <Form.Control type={"text"} placeholder="Enter OrderID"
                                                  onChange={(e) => setDetails({
                                                      ...details, orderId: e.target.value,
                                                  })}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Container>

                {/* Search Form */}
                <Container className="mt-4">
                    <h3 className="mb-3">Search Transactions</h3>
                    <Form onSubmit={handleTransaction}>
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Customer ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Customer ID"
                                        value={searchParams.customerId}
                                        onChange={(e) =>
                                            setSearchParams({
                                                ...searchParams,
                                                customerId: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={searchParams.startDate}
                                        onChange={(e) =>
                                            setSearchParams({
                                                ...searchParams,
                                                startDate: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={searchParams.endDate}
                                        max={new Date().toISOString().split("T")[0]}
                                        onChange={(e) =>
                                            setSearchParams({
                                                ...searchParams,
                                                endDate: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="primary" type="submit">
                            Search
                        </Button>
                    </Form>
                </Container>
            </div>
            {transactions.length === 0 ? (
                <div
                    style={{
                        marginTop: "50px",
                        marginBottom: "500px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    No transactions found
                </div>
            ) : (
                <div
                    className="cart-main-area pt-90 pb-100"
                    style={{marginTop: "50px"}}
                >
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="cart-page-title">
                                {searchParams.customerId} Transactions
                            </h3>
                        </div>
                        <Table
                            striped
                            bordered
                            hover
                            responsive
                            className="transaction-table"
                        >
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Order ID</th>
                                <th>Transaction Type</th>
                                <th>Amount</th>
                                <th>Hold</th>
                                <th>Open Balance</th>
                                <th>Close Balance</th>
                            </tr>
                            </thead>
                            <tbody>
                            {transactions.map((transaction, index) => (
                                <tr key={index}>
                                    <td>
                                        {convertUnixTimestampToDate(
                                            transaction.transactionTimeStamp
                                        )}
                                    </td>
                                    <td>{transaction.orderId}</td>
                                    <td>{transaction.transactionType}</td>
                                    <td>{`₹${transaction.amount}`}</td>
                                    <td>{`₹${transaction.hold}`}</td>
                                    <td>{`₹${transaction.openBalance}`}</td>
                                    <td>{`₹${transaction.closingBalance}`}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}
        </>
    );
};

export default TransactionForm;
